import React, { Component } from "react";
import UnderlinedButton from "../UnderlinedButton";
import PropTypes from "prop-types";
import { Event } from "../Tracking";

class EnergyChartGoToMaxEndDateLink extends Component {
  render() {
    return (
      <span className="fable:pl-8">
        <UnderlinedButton
          color="dark"
          onClick={() => {
            Event("Link Events", this.props.text, "(not set)");
            this.props.onClick();
          }}
        >
          {this.props.text}
        </UnderlinedButton>
      </span>
    );
  }
}

EnergyChartGoToMaxEndDateLink.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired
};

export default EnergyChartGoToMaxEndDateLink;
